module.exports = __webpack_public_path__ + "static/media/cinema.f4a70b5f.webp";